import { render, staticRenderFns } from "./FollowerCard.vue?vue&type=template&id=4479ab5b&scoped=true"
import script from "./FollowerCard.vue?vue&type=script&lang=js"
export * from "./FollowerCard.vue?vue&type=script&lang=js"
import style0 from "./FollowerCard.vue?vue&type=style&index=0&id=4479ab5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479ab5b",
  null
  
)

export default component.exports